import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { FaUserCircle } from "react-icons/fa";
import Logo from "../Assets/images/logo.png";
import { useAuth } from "../Context/AuthenticateProvider";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);
  const { isAuthenticated, role, logOut } = useAuth();

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="container">
        <nav className="navbar">

          {/* LOGO */}
          <Link className="navbar-brand" to="/" onClick={closeMenu}>
            <img src={Logo} alt="Geetha Alagappan Foundation" className="site-logo" />
          </Link>

          {/* DESKTOP NAV */}
          <div ref={menuRef} className={`nav-menu ${menuOpen ? "show" : ""}`}>

            {/* Drawer close (mobile) */}
            <button className="drawer-close" onClick={closeMenu} aria-label="Close menu">
              <FiX size={22} />
            </button>

            <ul className="nav-list">
              {role !== "admin" && (
                <>
                  <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
                  <li><NavLink to="/about" onClick={closeMenu}>About Us</NavLink></li>
                  <li><NavLink to="/publicview" onClick={closeMenu}>Requests</NavLink></li>
                  <li><NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink></li>
                  <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>
                  <li><NavLink to="/donators" onClick={closeMenu}>Donators</NavLink></li>
                </>
              )}

              {isAuthenticated && role === "donor" && (
                <>
                  <li><NavLink to="/donate" onClick={closeMenu}>Donate</NavLink></li>
                  <li><NavLink to="/my-payments" onClick={closeMenu}>My Payments</NavLink></li>
                </>
              )}

              {isAuthenticated && role === "user" && (
                <li>
                  <NavLink to="/my-requests" onClick={closeMenu}>My Requests</NavLink>
                </li>
              )}

              {isAuthenticated && role === "admin" && (
                <>
                  <li><NavLink to="/dashboard" onClick={closeMenu}>Dashboard</NavLink></li>
                  <li><NavLink to="/review" onClick={closeMenu}>Review</NavLink></li>
                  <li><NavLink to="/payment-list" onClick={closeMenu}>Payments</NavLink></li>
                  <li><NavLink to="/userlist" onClick={closeMenu}>Users</NavLink></li>
                  <li><NavLink to="/email-status" onClick={closeMenu}>Email Status</NavLink></li>
                </>
              )}
            </ul>

            {/* CTA GROUP */}
            <div className="nav-actions">
              {!isAuthenticated && role !== "admin" && (
                <NavLink to="/request" className="nav-cta-btn" onClick={closeMenu}>
                  Raise Fund
                </NavLink>
              )}

              {isAuthenticated && role === "user" && (
                <NavLink to="/profile" className="nav-profile-btn" onClick={closeMenu} title="Profile">
                  <FaUserCircle size={26} />
                </NavLink>
              )}

              {isAuthenticated && (
                <button
                  className="nav-logout-btn"
                  onClick={() => { closeMenu(); logOut(); }}
                >
                  Logout
                </button>
              )}
            </div>

          </div>

          {/* MOBILE TOGGLE */}
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>

        </nav>
      </div>

      {/* Drawer backdrop */}
      {menuOpen && <div className="nav-backdrop" onClick={closeMenu} />}
    </header>
  );
}